var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStationary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F98883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 10.2C6.6 8.4325 8.0325 7 9.8 7H16.2C17.9675 7 19.4 8.4325 19.4 10.2V11.04C18.4875 11.225 17.8 12.0325 17.8 13V14.2H8.2V13C8.2 12.0325 7.5125 11.225 6.6 11.04V10.2ZM18.6 13C18.6 12.4775 18.935 12.0325 19.4 11.8675C19.525 11.8225 19.66 11.8 19.8 11.8C20.4625 11.8 21 12.3375 21 13V17.4C21 17.8425 20.6425 18.2 20.2 18.2H19.4C18.9575 18.2 18.6 17.8425 18.6 17.4H7.4C7.4 17.8425 7.0425 18.2 6.6 18.2H5.8C5.3575 18.2 5 17.8425 5 17.4V13C5 12.3375 5.5375 11.8 6.2 11.8C6.34 11.8 6.475 11.825 6.6 11.8675C7.065 12.0325 7.4 12.4775 7.4 13V14.2V15H8.2H17.8H18.6V14.2V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationary);
export default __webpack_public_path__ + "static/media/stationary.108c524b4b9a8282305594bf9041ff79.svg";
export { ForwardRef as ReactComponent };